module.exports = __webpack_public_path__ + "static/media/no-search-result.63bfbf40.svg";